<template>
  <ArticleList 
    type="project" 
    page-title="项目" 
    page-subtitle="从 idea 到落地的完整实践" 
  />
</template>

<script>
import ArticleList from './ArticleList.vue'

export default {
  name: 'ProjectArticleList',
  components: { ArticleList }
}
</script>
